export default {
  name: "Search",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "m29.21 27.79-8.11-8.11c1.5-1.82 2.4-4.15 2.4-6.68 0-5.79-4.71-10.5-10.5-10.5S2.5 7.21 2.5 13 7.21 23.5 13 23.5c2.54 0 4.86-.9 6.68-2.41l8.11 8.11c.39.39 1.02.39 1.41 0s.4-1.02.01-1.41zM4.5 13c0-4.69 3.81-8.5 8.5-8.5s8.5 3.81 8.5 8.5-3.81 8.5-8.5 8.5-8.5-3.81-8.5-8.5z",
  },
}
